export default "https://cdn-static.gokick.com/assets/713f881f9452b025a6ed3fcaec249d98fea8bb41/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";